import { render, staticRenderFns } from "./PriceBox.vue?vue&type=template&id=721475a6&scoped=true"
import script from "./PriceBox.vue?vue&type=script&lang=js"
export * from "./PriceBox.vue?vue&type=script&lang=js"
import style0 from "./PriceBox.vue?vue&type=style&index=0&id=721475a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721475a6",
  null
  
)

export default component.exports